var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('b-button',{staticClass:"text-danger",attrs:{"variant":"link"},on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"fa fa-hand-o-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Regresar\n\t\t")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }